import s from "./contact-channels138.js";
import r from "./contact-channels139.js";
import i from "./contact-channels140.js";
import t from "./contact-channels141.js";
import v from "./contact-channels142.js";
import e from "./contact-channels143.js";
import a from "./contact-channels144.js";
import n from "./contact-channels145.js";
import m from "./contact-channels146.js";
import p from "./contact-channels147.js";
import _ from "./contact-channels148.js";
import o from "./contact-channels149.js";
import f from "./contact-channels150.js";
import C from "./contact-channels151.js";
const S = {
  da_dk: {
    vistaprint: s
  },
  en_us: {
    vistaprint: r
  },
  en_ca: {
    vistaprint: r
  },
  de_de: {
    vistaprint: i
  },
  de_ch: {
    vistaprint: i
  },
  de_at: {
    vistaprint: i
  },
  en_au: {
    vistaprint: t
  },
  en_gb: {
    vistaprint: t
  },
  en_ie: {
    vistaprint: t
  },
  en_in: {
    vistaprint: t
  },
  en_nz: {
    vistaprint: t
  },
  en_sg: {
    vistaprint: t
  },
  es_es: {
    vistaprint: v
  },
  es_us: {
    vistaprint: e
  },
  fi_fi: {
    vistaprint: a
  },
  fr_be: {
    vistaprint: n
  },
  fr_ca: {
    vistaprint: m
  },
  fr_ch: {
    vistaprint: n
  },
  fr_fr: {
    vistaprint: n
  },
  it_ch: {
    vistaprint: p
  },
  it_it: {
    vistaprint: p
  },
  nb_no: {
    vistaprint: _
  },
  nl_be: {
    vistaprint: o
  },
  nl_nl: {
    vistaprint: o
  },
  pt_pt: {
    vistaprint: f
  },
  sv_se: {
    vistaprint: C
  }
};
export {
  S as default
};
//# sourceMappingURL=contact-channels77.js.map
